<app-sick-header applicationTitle="Artifact Repository"></app-sick-header>
<div class="navigation-tabs-style">
  <p-tabMenu [model]="items"></p-tabMenu>
</div>
<router-outlet></router-outlet>
<p-toast position="bottom-right"></p-toast>
